import React from 'react';
import { Navigate } from 'react-router-dom';

import { useTheme } from '../theme/ThemeContext';
import { usePermissions } from '../context/PermissionContext';
import FeesSettings from '../components/settings/FeesSettings';
import FeesBillingTabs from '../components/settings/FeesBillingTabs';
import AdminPageHeader from '../components/common/AdminPageHeader';
import './FeesBillingPage.css';

/**
 * Fees & Billing — landing page.
 *
 * First tab: Consultation Fees (wraps the existing FeesSettings component).
 * Other tabs (Procedure Catalog / Doctor Rate Overrides) are separate
 * routes that share the FeesBillingTabs strip, so from the user's
 * perspective the whole section feels like one tabbed area.
 *
 * Authorization is enforced by the AdminDashboard card visibility +
 * every FeesSettings API request (MANAGE_FEES server-side).
 */
export default function FeesBillingPage() {
  const { isDark } = useTheme();
  const { hasPermission } = usePermissions();

  const bg = isDark
    ? 'linear-gradient(135deg, #0E0E0F 0%, #1a1a2e 50%, #0E0E0F 100%)'
    : 'linear-gradient(135deg, #f8fafc 0%, #eef2ff 50%, #f8fafc 100%)';

  // Permission gate (after all hooks)
  if (!hasPermission('MANAGE_STAFF')) {
    return <Navigate to="/access-denied" replace />;
  }

  return (
    <div className="fbp-page" style={{ background: bg }}>
      <AdminPageHeader />

      <main className="fbp-main">
        <div className="fbp-title-row">
          <h1 className="fbp-title" style={{ color: isDark ? '#f5f5f7' : '#111827' }}>
            ₹ Fees &amp; Billing
          </h1>
          <p className="fbp-subtitle" style={{ color: isDark ? '#9ca3af' : '#6b7280' }}>
            Consultation fees · Procedure catalog · Per-doctor rate overrides
          </p>
        </div>
        <FeesBillingTabs active="consultation" />
        <div className="fbp-body">
          <FeesSettings />
        </div>
      </main>
    </div>
  );
}
